<template>
  <div class="page-container">
    <TopBack :title="name"/>
    <div style="margin-top: 10px" v-if="image">
        <img :src="image" class="header-image" />
    </div>
    <div class="introduction">
        <span>{{$t('lang.bonusActivity.holi.introduction')}}</span>
    </div>
    <div class="today-date">
        <span>{{todayDate}}</span>
    </div>
    <div v-for="(item, index) in optionList"
         :key="index">
        <div class="option-item"
             :class="{'selected': selectedOption==item.OptionCode || attendOption == item.OptionCode}"
             @click="selectOption(item.OptionCode)"
             v-if="attendOption == '' || attendOption == item.OptionCode">
            <div class="option-title">
              <span>{{$t('lang.bonusActivity.holi.dailyGoal')}}</span>
              <span style="margin-left: 10px">{{index+1}}</span>
            </div>
            <div class="option-content">
                <div class="left">
                  <span>{{$t('lang.bonusActivity.holi.bet')}}</span>
                  <span style="margin-left: 10px">₹ {{item.PlanBetAmount}}</span>
                </div>
                <div class="right">
                  <span>+ ₹ {{item.BonusAmount}}</span>
                  <span style="margin-left: 10px">{{$t('lang.bonusActivity.holi.bonus')}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="bonus-progress" v-if="betGoal > 0">
      <div class="left"><span>{{$t('lang.bonus.completed')}}</span></div>
      <div class="progress">
        <div class="progress-done" :style="{width: betAmount<betGoal? betAmount*100/betGoal + '%': 100 + '%'}"></div>
      </div>
      <div class="right"><span>+₹ {{separateThousand(betAmount)}}</span></div>
    </div>
    <div>

    </div>
    <div class="play-btn" @click="attendActivity" v-if="!attendOption">
      <span>{{$t('lang.common.submit')}}</span>
    </div>
    <div class="play-btn" @click="collectBonus" v-if="attendOption">
      <span>{{$t('lang.bonusActivity.holi.collect')}}</span>
    </div>
    <div class="rule-tile">
      <span>{{$t('lang.bonusActivity.holi.howDoesTitle')}}</span>
    </div>
    <div class="rules">
      <div v-for="(item, index) in $t('lang.bonusActivity.holi.howDoesItems')"
           :key="index">
        <div class="rule-item">
          <div class="rule-number">
            <span>{{index+1}}</span>
          </div>
          <div class="rule-content">
            <div class="rule-title">
              <span>{{item}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import store from '../../store/store'
import {Toast, MessageBox} from 'mint-ui'
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import {separateThousand} from '@/utils'

export default {
  name: 'GameCompetition',
  components: {
    TopBack,
    MessageBox
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      activityCode: '',
      name: '',
      image: '',
      optionList: [],
      isActive: false,
      todayDate: '',
      attendOption: '',
      betGoal: 0,
      betAmount: 0,
      selectedOption: '',
      separateThousand
    }
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    getData () {
      if (this.activityCode) {
        const data = {
          UserId: this.userInfo.UserId,
          ActivityCode: this.activityCode,
          internation: this.$store.state.internation
        }
        request('post', '/innovation/activity/getActivity', data)
          .then(res => {
            if (res.Code === 1) {
              this.name = res.Name
              this.image = res.Image
              this.optionList = res.OptionList
              this.isActive = res.IsActive
              this.todayDate = res.TodayDate
              this.attendOption = res.AttendOption
              this.betGoal = res.BetGoal
              this.betAmount = res.BetAmount
            } else {
              Toast(this.$t('lang.common.errorPrompt'))
            }
          }).catch(err => {
            console.log(err)
            Toast(this.$t('lang.common.errorPrompt'))
          })
      }
    },
    selectOption (optionCode) {
      if (!this.attendOption) {
        this.selectedOption = optionCode
        console.log(this.selectedOption)
      }
    },
    attendActivity: function () {
      if (this.selectedOption) {
        console.log(this.selectedOption)
        MessageBox
          .confirm(
            this.$t('lang.bonusActivity.holi.confirmSelect'),
            {
              title: this.$t('lang.messageBox.confirm'),
              confirmButtonText: this.$t('lang.messageBox.ok'),
              cancelButtonText: this.$t('lang.messageBox.cancel')
            })
          .then(action => {
            console.log(action)
            this.toAttendActivity()
          })
          .catch(() => {
          })
      } else {
        Toast(this.$t('lang.bonusActivity.holi.selectGoal'))
      }
    },
    toAttendActivity: function () {
      const data = {
        UserId: this.userInfo.UserId,
        ActivityCode: this.activityCode,
        OptionCode: this.selectedOption,
        internation: this.$store.state.internation
      }
      request('post', '/innovation/activity/attend', data)
        .then(res => {
          if (res.Code > 0) {
            switch (res.Code) {
              // 成功
              case 1:
                this.getData()
                break
              // 未开始
              case 2:
                Toast(this.$t('lang.bonusActivity.holi.eventNotStart'))
                break
              // 已结束
              case 3:
                Toast(this.$t('lang.bonusActivity.holi.eventEnd'))
                break
              // 不符合参加条件
              case 4:
                Toast(this.$t('lang.bonusActivity.holi.notEligible'))
                break
            }
          } else {
            Toast(this.$t('lang.common.errorPrompt'))
          }
        }).catch(err => {
          console.log(err)
          Toast(this.$t('lang.common.errorPrompt'))
        })
    },
    collectBonus: function () {
      const data = {
        UserId: this.userInfo.UserId,
        ActivityCode: this.activityCode,
        internation: this.$store.state.internation
      }
      request('post', '/innovation/activity/collectbonus', data)
        .then(res => {
          if (res.Code > 0) {
            switch (res.Code) {
              // 成功
              case 1:
                Toast(this.$t('lang.bonusActivity.holi.hasCollectedBonus'))
                this.$router.push({name: 'Bonus', query: {}})
                break
              // 未参加
              case 2:
                Toast(this.$t('lang.bonusActivity.holi.notParticipate'))
                break
              // 已领取
              case 3:
                Toast(this.$t('lang.bonusActivity.holi.hasCollectedBonus'))
                this.$router.push({name: 'Bonus', query: {}})
                break
              // 不符合参加条件
              case 4:
                Toast(this.$t('lang.bonusActivity.holi.notEligible'))
                break
              // 未完成
              case 5:
                Toast(this.$t('lang.bonusActivity.holi.notCompleted'))
                break
            }
          } else {
            Toast(this.$t('lang.common.errorPrompt'))
          }
        }).catch(err => {
          console.log(err)
          Toast(this.$t('lang.common.errorPrompt'))
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.activityCode = to.query.param
      vm.getData()
    })
  }
}
</script>

<style scoped lang="less" >
  .page-container{
    padding: 0 0 100px 0;

    .header-image{
      width: 100%;
      display: block;
    }

    .introduction {
      font-size: 16px;
      margin: 10px 10px;
      line-height: 20px;
      color: #FFFFFF;
    }

    .today-date{
      font-size: 22px;
      font-weight: bold;
      color: #f6d9aa;
      text-align: center;
      margin: 0 0 20px 0;
    }

    .option-item {
      margin: 0px 10px 10px 10px;
      line-height: 20px;
      border: 1px solid rgba(246,217,170,.5);
      border-radius: 6px;
      padding: 5px 15px;

      .option-title {
        color: #f6d9aa;
        margin: 0 0 10px 0;
        font-size: 18px;
      }

      .option-content{
        display: flex;
        color: #FFFFFF;
        font-size: 16px;
        .left {
          flex: 1;
          text-align: left;
        }

        .right {
          flex: 1;
          text-align: right;
        }
      }
    }

    .selected {
      color: #000;
      background-color: #2f2f2f;

      .option-title {
        font-weight: bold;
      }
    }

    .bonus-progress {
      display: flex;
      padding-top: 10px;
      font-size: 12px;
      margin: 0 10px;
      /*width: 345px;*/

      .left{
        padding-left: 15px;
        margin-right: auto;
        width: 80px;
      }
      .progress{
        border-radius: 5px;
        position: relative;
        margin: 3px 10px;
        height: 7px;
        width: calc(100vw - 100px - 20px - 80px - 20px);
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 12px;
        .progress-done {
          background: #FFC700;
          border-radius: 12px;
          width: 0;
          height: 5px;
          transition: width 1s ease 0.3s;
        }
      }
      .right{
        color: #EDB905;
        margin-right: 12px;
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-align: right;
      }
    }

    .rule-tile {
      font-size: 16px;
      font-weight: bold;
      color: #f6d9aa;
      margin: 15px 10px;
    }

    .rules{
      margin: 0px 10px 0px 10px;

      .rule-item{
        display: flex;
        margin-bottom: 10px;
        .rule-number{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #F6D9AA;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          color: #F6D9AA;
        }
        .rule-content{
          width: calc(100vw - 32px - 40px);
          padding: 0 0px 0 10px;
          .rule-title{
            color: #F6D9AA;
            font-size: 16px;
            line-height: 20px;
            margin: 0 0 5px 0;
          }
          .rule-description{
            color: #DADADA;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }

    .play-btn{
      background: #F6D9AA;
      border-radius: 6px;
      line-height: 20px;
      padding: 12px 0px;
      text-align: center;
      color: #000D2E;
      font-size: 20px;
      margin: 30px 10px 30px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BonusActivity/index.vue